import { useGetCapitalEventMenuItems } from "features/capital-activity/event/CapitalEventMenu";
import { FundFamilyEventAPIData } from "gen/model/fundFamilyEventAPIData";
import React from "react";
import { useNavigate } from "react-router";
import { PageMenu } from "shared/components/layout/PageMenu";
import { rootRoute } from "shared/navigation/Routes";

export const CapitalEventPageMenu: React.FC<{
  fundFamilyId: string;
  fundFamilyEventId: string;
  activityData: FundFamilyEventAPIData;
}> = ({ fundFamilyId, fundFamilyEventId, activityData }) => {
  const navigate = useNavigate();
  const getMenuItems = useGetCapitalEventMenuItems(fundFamilyId, () => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .capitalActivity({}).$,
    );
  });
  const menuItems = getMenuItems(fundFamilyEventId, activityData.state);
  if (!menuItems.length) {
    return null;
  }
  return <PageMenu>{menuItems}</PageMenu>;
};
